import { Add, Delete, Settings, Sync } from "@material-ui/icons";
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, withStyles, Button, Grid } from "@material-ui/core";
import { IUserDataTableProps } from "./props";
import "./felhasznalokezelo-table.scss";
import { IUserData } from "../../../web-services/models/user-data";
import { useEffect, useState } from "react";
import * as AuthService from "../../../web-services/auth-service";

export function FelhasznalokezeloTable(props: IUserDataTableProps)
{

    const [currentUser, setCurrentUser] = useState<IUserData | undefined>(undefined);


    useEffect(() => {
        const user = AuthService.getCurrentUser();

        if (user) {
            setCurrentUser(user);
        }

    }, []);

    return (
        <TableContainer component={Paper} className="felhasznalokezelo-table" > <Grid container spacing={2}>
            <Grid item xs={12} sm={8} />
            <Grid item xs={12} sm={4} className="vjt-getter-button-item" >
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<Add />}
                    onClick={() => props.onCreateNewButtonClick()}

                >
                    Új Felhasználó létrehozás
                </Button>
            </Grid>
        </Grid>
            <Table>
            <TableHead>
                    <TableRow>
                    <TableCell>Id</TableCell>
                    <TableCell>Felhasználónév</TableCell>
                    <TableCell>Teljes név</TableCell>
                    <TableCell>Jogosultság</TableCell>
                </TableRow>
                </TableHead>
            <TableBody>
                    {props.data.map((row, i) => (
                    <TableRow
                            key={i}
                        >
                            <TableCell>{row.id}</TableCell>
                            <TableCell>{row.username}</TableCell>
                            <TableCell>{row.name}</TableCell>
                            <TableCell> {row.roles && row.roles.length > 0 ? (
                            row.roles.map(role => role.name).join(", ")
                        ) : (
                            "No roles" // Display a message when roles are not available
                        )}
                        </TableCell>

                            <TableCell>
                            <Button color="primary" variant="contained" startIcon={<Settings />} onClick={() => props.onModifyButtonClick(row)}>
                                    Módosítom
                                </Button>
                                {currentUser?.id != row.id ? (
                                    <Button color="secondary" variant="contained" startIcon={<Delete />} onClick={() => props.onRemoveButtonClick(row)}>
                                        Törlés
                                    </Button>
                                ) : undefined}
                        </TableCell>
                        </TableRow>
                ))}
                </TableBody>
        </Table>
        </TableContainer>
    );
}
